import { useNavigate } from 'react-router-dom';
import styles from '../styles/AccountOptions.module.css';
import BusinessImage from '../images/VenueImage.png';
import GroupMemberImage from '../images/GroupMemberImage.png';

/** Page component where users select which account type they want to sign up for */
const AccountOptions = () => {
  const navigate = useNavigate();

  return (
    <div className={styles.container}>
      {/* Floating orbs */}
      <div className={`${styles.orb} ${styles.orbGold}`} />
      <div className={`${styles.orb} ${styles.orbGreen}`} />

      <div className={styles.inner}>
        {/* Logo */}
        <img
          onLoad={(e) => e.currentTarget.classList.add('loaded')}
          src="/GroupSoup.png"
          alt="GroupSoup"
          className={styles.logoImg}
        />

        {/* Heading */}
        <h1 className={styles.title}>Join GroupSoup</h1>
        <p className={styles.subtitle}>Select an account type to continue</p>

        {/* Options */}
        <div className={styles.options}>
          {/* Venue Owner */}
          <button
            className={`${styles.optionCard} ${styles.venueCard}`}
            onClick={() => navigate('/sign-up/venue')}
            type="button"
          >
            <img
              onLoad={(e) => e.currentTarget.classList.add('loaded')}
              src={BusinessImage}
              alt="Venue"
              className={styles.cardImg}
            />
            <div className={styles.cardText}>
              <span className={styles.cardTitle}>Venue Owner</span>
              <span className={styles.cardDesc}>
                Advertise your venue and host community events
              </span>
            </div>
            <span className={styles.cardArrow}>→</span>
          </button>

          {/* Group Member */}
          <button
            className={`${styles.optionCard} ${styles.memberCard}`}
            onClick={() => navigate('/sign-up/member')}
            type="button"
          >
            <img
              onLoad={(e) => e.currentTarget.classList.add('loaded')}
              src={GroupMemberImage}
              alt="Group Member"
              className={styles.cardImg}
            />
            <div className={styles.cardText}>
              <span className={styles.cardTitle}>Group Member</span>
              <span className={styles.cardDesc}>
                Engage with communities and attend events
              </span>
            </div>
            <span className={styles.cardArrow}>→</span>
          </button>
        </div>

        {/* Back */}
        <button className={styles.backLink} onClick={() => navigate('/')}>
          ← Back to home
        </button>
      </div>
    </div>
  );
};

export default AccountOptions;
